import React, { useEffect, useState } from 'react';
import { FiSearch } from 'react-icons/fi';

export function selectionLabel(allSelected, selected, options, one, many) {
    if (allSelected) return 'All';
    if (!selected.length) return 'None';
    if (selected.length === 1) {
        const match = options.find((item) => item.id === selected[0]);
        return match ? match.label : one;
    }
    return `${selected.length} ${many}`;
}

export function chooseAllSelection(setAll, setSelected) {
    setAll(true);
    setSelected([]);
}

export function resetSelection(setAll, setSelected) {
    setAll(false);
    setSelected([]);
}

export function toggleSelection(id, allSelected, setAll, selected, setSelected, options) {
    const allIds = options.map((option) => option.id);
    const current = allSelected ? allIds : selected;
    const next = current.includes(id)
        ? current.filter((item) => item !== id)
        : current.concat(id);
    if (allIds.length && next.length === allIds.length) {
        setAll(true);
        setSelected([]);
        return;
    }
    setAll(false);
    setSelected(next);
}

function optionMatches(option, needle) {
    if (!needle) return true;
    if (String(option.label || '').toLowerCase().indexOf(needle) !== -1) return true;
    return String(option.mark || '').toLowerCase().indexOf(needle) !== -1;
}

const MultiFilter = ({
    label,
    open,
    onOpen,
    buttonLabel,
    allSelected,
    onChooseAll,
    options,
    selectedIds,
    onToggle,
    onReset,
    emptyText,
}) => {
    const [query, setQuery] = useState('');

    useEffect(() => {
        if (!open) setQuery('');
    }, [open]);

    const needle = query.trim().toLowerCase();
    const visible = needle ? options.filter((option) => optionMatches(option, needle)) : options;
    const noneSelected = !allSelected && selectedIds.length === 0;

    const onAllChange = () => {
        if (allSelected) onReset();
        else onChooseAll();
    };

    return (
        <div className={`filter-chip multi-filter${allSelected ? '' : ' is-on'}`}>
            <span>{label}</span>
            <button
                type="button"
                className="people-toggle"
                aria-label={label}
                aria-expanded={open}
                aria-haspopup="true"
                onClick={onOpen}
            >
                {buttonLabel}
            </button>
            {open && (
                <div className="people-menu" role="group" aria-label={`${label} options`}>
                    <div className="filter-menu-search">
                        <FiSearch aria-hidden="true" />
                        <input
                            type="search"
                            placeholder="Search..."
                            aria-label={`Search ${label}`}
                            value={query}
                            autoFocus
                            autoComplete="off"
                            onChange={(event) => setQuery(event.target.value)}
                        />
                        <button
                            type="button"
                            className="filter-menu-reset"
                            onClick={onReset}
                            disabled={noneSelected}
                        >
                            Reset
                        </button>
                    </div>
                    <div className="filter-menu-list">
                        <label className="people-opt">
                            <input type="checkbox" checked={allSelected} onChange={onAllChange} />
                            All
                        </label>
                        {options.length === 0 && <div className="side-empty">{emptyText}</div>}
                        {options.length > 0 && visible.length === 0 && <div className="side-empty">No matches.</div>}
                        {visible.map((option) => (
                            <label className="people-opt" key={option.id}>
                                <input
                                    type="checkbox"
                                    checked={allSelected || selectedIds.includes(option.id)}
                                    onChange={() => onToggle(option.id)}
                                />
                                {option.color ? (
                                    <span className="av" style={{ background: option.color }}>{option.mark || ''}</span>
                                ) : null}
                                {option.label}
                            </label>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default MultiFilter;
